/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkAlcoBottleWineIcon24Solid = forwardRef('FoodDrinkAlcoBottleWineIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 1.25C10 .56 10.56 0 11.25 0h1.5C13.44 0 14 .56 14 1.25v5.591c2.33.824 4 3.047 4 5.659v9a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 6 21.5v-9a6.002 6.002 0 0 1 4-5.659V1.25ZM8.5 12a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-7Z" })));
});
